import { IDonorProfileHlaInfoData } from "@nkr/models/donor-profile";

export const updateProfileHlaInfo = {
    onNumericChange: (name: string, value: number, data: IDonorProfileHlaInfoData) => {
        data[name] = value;

        return data;
    },

    onTextChange: (name: string, value: string, data: IDonorProfileHlaInfoData) => {
        switch (name) {
            case 'labReviewedAntigensDate': data.labReviewDate = value; break;
        }

        return data;
    },

    onBooleanChange: (name: string, value: boolean, data: IDonorProfileHlaInfoData) => {
        switch (name) {
            case 'hlaDr51': data.hlaHasDr51 = value; break;
            case 'hlaDr52': data.hlaHasDr52 = value; break;
            case 'hlaDr53': data.hlaHasDr53 = value; break;
        }

        return data;
    },

    onDateChange: (name: string, value: string, data:IDonorProfileHlaInfoData) => {
        data[name] = value;

        return data;
    }
}